export default __webpack_public_path__ + "static/media/2.BeximcoPharmaceuticalsLtd.(Tongi).ccf3d75f.jpg";